import React, { useState } from "react";
import { Save, X, Loader2 } from "lucide-react";
import { api } from "../../adminApi";
import { Card, Field, Input, Select, Btn, LocalizedInput } from "../../components/admin/AdminUI";
import { ImageUploader } from "../../components/admin/MediaUploader";

export const CATEGORIES = ["Residential", "Retail", "Hospitality", "Wellness", "Healthcare", "Office", "F&B"];

const empty = {
  slug: "",
  title: { en: "", fi: "" },
  description: { en: "", fi: "" },
  category: "Residential",
  location: "",
  year: "",
  client: "",
  scope: "",
  images: [],
  featured: true,
  order: 0,
};

export default function ProjectForm({ project, onSaved, onCancel }) {
  const [form, setForm] = useState({ ...empty, ...(project || {}) });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  const setEv = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setErr("");
    if (!form.title.en.trim()) {
      setErr("Proje başlığı (EN) zorunludur.");
      return;
    }
    setBusy(true);
    const body = {
      slug: form.slug,
      title: form.title,
      description: form.description,
      category: form.category,
      location: form.location,
      year: form.year,
      client: form.client,
      scope: form.scope,
      images: form.images,
      featured: !!form.featured,
      order: Number(form.order) || 0,
    };
    try {
      const saved = project?.id ? await api.updateProject(project.id, body) : await api.createProject(body);
      onSaved(saved);
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="p-6 lg:p-8 mb-8" data-testid="project-form">
      <div className="flex items-center justify-between mb-7">
        <p className="mono text-[9px] text-[#8C7862]">
          {project?.id ? "[ PROJEYİ DÜZENLE ]" : "[ YENİ PROJE ]"}
        </p>
        <button onClick={onCancel} className="text-[#6B675F] hover:text-[#141414]" data-testid="project-form-close">
          <X size={18} strokeWidth={1.6} />
        </button>
      </div>

      <form onSubmit={save} className="space-y-6">
        <LocalizedInput label="PROJE BAŞLIĞI" value={form.title} onChange={set("title")} />
        <LocalizedInput label="PROJE AÇIKLAMASI" value={form.description} onChange={set("description")} multiline rows={5} />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Field label="KATEGORİ">
            <Select value={form.category} onChange={setEv("category")} data-testid="project-category">
              {CATEGORIES.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </Select>
          </Field>
          <Field label="KONUM">
            <Input value={form.location} onChange={setEv("location")} data-testid="project-location" />
          </Field>
          <Field label="YIL">
            <Input value={form.year} onChange={setEv("year")} data-testid="project-year" />
          </Field>
          <Field label="MÜŞTERİ">
            <Input value={form.client} onChange={setEv("client")} data-testid="project-client" />
          </Field>
          <Field label="KAPSAM">
            <Input value={form.scope} onChange={setEv("scope")} data-testid="project-scope" />
          </Field>
          <Field label="SIRA NO" hint="Küçük sayı önce görünür">
            <Input type="number" value={form.order} onChange={setEv("order")} data-testid="project-order" />
          </Field>
        </div>

        <ImageUploader images={form.images} onChange={set("images")} testid="project-images" />

        {err && (
          <p className="text-[13px] text-[#8C2E1D] border border-[#D9B7AE] bg-[#FBF1EE] px-4 py-3">{err}</p>
        )}

        <div className="flex gap-3 pt-2">
          <Btn type="submit" disabled={busy} data-testid="project-save">
            {busy ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} strokeWidth={1.7} />}
            {busy ? "KAYDEDİLİYOR..." : "KAYDET"}
          </Btn>
          <Btn type="button" variant="ghost" onClick={onCancel}>
            VAZGEÇ
          </Btn>
        </div>
      </form>
    </Card>
  );
}
